import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "@material-ui/core";
import SeoManager from "./seoManager";
import { BrowserRouter, Route, Redirect, Routes } from "react-router-dom";
import theme from "../theme/theme";
import Main from "./Main";
import TermsConditions from "./Footer/FooterSections/Terms&Conditions";
import AboutKM from "./Footer/FooterSections/AboutKM";
import Partnerships from "./Footer/FooterSections/Partnerships";
import Career from "./Footer/FooterSections/Career";
import PricingAndRefund from "./Footer/FooterSections/PricingAndRefund";
import PrivacyPolicy from "./Footer/FooterSections/PrivacyPolicy";
import FAQs from "./Footer/FooterSections/FAQs";
import SportsVenuePage from "./SportsPages/SportsVenuePage";
import ListVenuePage from "./ListYourVenuePage/index";
import RxLanding from "./VpccPages/VpccRxPage/RxLanding";
import HostGamePage from "./HostGames/HostGamePage";

const client = new ApolloClient({
  uri: `${process.env.REACT_APP_API_URL}`,
  cache: new InMemoryCache(),
});

export default function App() {

   function ScrollToTop() {
      const { pathname } = useLocation();
    
      useEffect(() => {
        window.scrollTo(0, 0);
      }, [pathname]);
    
      return null;
    };

  return (
    <ApolloProvider client={client}>
      <SeoManager />
      <ThemeProvider theme={theme}>
        <BrowserRouter>
        <ScrollToTop />
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/vpcc-x-rx-cricket-academy" element={<RxLanding />} />
            <Route path="/games" element={<HostGamePage />} />
            <Route path="/list-your-sports-venue" element={<ListVenuePage />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/about-us" element={<AboutKM />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/pricing-policy" element={<PricingAndRefund />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/faq" element={<FAQs />} />
            <Route path="/:slug" element={<SportsVenuePage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </ApolloProvider>
  );
}
